import React, { Component } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import { isEmpty, cloneDeep, get } from 'lodash';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import {
  CHECKIN_DATE,
  CHECKOUT_DATE,
  ROOMS_FIELDNAME,
  SUBMIT_TEXT,
  ISREQUIRED_TEXT,
  DATE_TEXT,
  ADULTS_TEXT,
  FORM_TYPE_TO_CHECK_HOTEL,
} from './Constants';
import Form from '../../../../components/organism/form';
import SelectMUI from '../../../../components/atoms/Forms/Select';
import RadioMUI from '../../../../components/atoms/Forms/Radio';
import ButtonMUI from '../../../../components/atoms/Button';
import Calender from '../../../../components/atoms/Forms/Calendar';
import AutoCompleteMUI from '../../../../components/atoms/AutoComplete';
import HotelGuestWidget from '../../../../components/molecules/HotelGuestWidget';
import { pushAnaylyticsData } from '../../../../../../src/utils/analytics';
import { analyticsData } from '../../../../../../src/constants/Analytics/analytics-data';
import { createDynamicLabels } from '../../../../../utils/analytics';
import { getDictionaryText } from '../../../../utils/getDictionaryText';

class HotelForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: [],
      widgetForm: [],
    };
    this.mapper = {
      Dropdown: SelectMUI,
      RadioButtonList: RadioMUI,
      DateRange: Calender,
      Date: Calender,
      Submit: ButtonMUI,
      AutoComplete: AutoCompleteMUI,
    };
    this.HotelsPayload = {};
    this.shouldUseWidgetData = false;
    this.widgetPayload = {};
    this.redirectSitecoreURL = '';
    this.rules = [];
    this.fieldDataToRepeat = {};
    this.language = get(props, 'sitecoreContext.language', '');
  }

  componentDidMount() {
    let { formData, widgetForm } = this.props;
    let widgetData = [];
    let widget = {};
    formData.map(data => {
      if (get(data, 'fields.defaultValue')) {
        const { defaultValue } = data.fields;
        if (get(data, 'fields.fieldName.value') === ROOMS_FIELDNAME) {
          this.addToHotelPayload(
            data.fields.fieldName.value,
            defaultValue && defaultValue.fields
          );
        }
        data.fields.selectedValue = {
          value: get(defaultValue, 'fields.key.value'),
        };
      }
      if (get(data, 'fields.fieldType.value') === DATE_TEXT) {
        data.fields.startDate = { value: '' };
        data.fields.startDateName = { value: CHECKIN_DATE };
        data.fields.endDate = { value: '' };
        data.fields.endDateName = { value: CHECKOUT_DATE };
      } else if (get(data, 'fields.fieldType.value') !== SUBMIT_TEXT) {
        const isrequired = get(data, 'fields.isRequired.value')
          ? ISREQUIRED_TEXT
          : '';
        const rulesObject = {
          fieldName: get(data, 'fields.fieldName.value'),
          rules: isrequired ? [isrequired] : [],
        };
        this.rules.push(rulesObject);
      }
      return data;
    });
    widgetForm &&
      widgetForm.map(data => {
        widget.fields = cloneDeep(get(data, 'fields.fields'));
        widget.removeLabel = cloneDeep(get(data, 'fields.removeLabel'));
        widget.roomLabel = cloneDeep(get(data, 'fields.roomLabel'));
        return data;
      });
    this.fieldDataToRepeat = cloneDeep(widget);
    widgetData = [...widgetData, this.addWidgetData(1, '1')];

    this.setState({
      formData: formData,
      widgetForm: widgetForm,
      widgetData: widgetData,
    });
  }

  // #TODO : Use proper idenfying name
  addWidgetData = (key, value) => {
    let data = cloneDeep(this.fieldDataToRepeat);
    data &&
      data.fields &&
      data.fields.length > 0 &&
      data.fields.map(field => {
        /* istanbul ignore else */
        if (get(field, 'fields.defaultValue')) {
          const { defaultValue } = field && field.fields;
          field.fields.fieldName.value = `${get(
            field,
            'fields.fieldName.value'
          )}_${key}`;
          field.fields.selectedValue = {
            value: get(defaultValue, 'fields.key.value'),
          };
          this.addToWidgetPayload(
            get(field, 'fields.fieldName.value'),
            get(defaultValue, 'fields.key.value'),
            true
          );
        }
        return field;
      });
    this.addToWidgetPayload(ROOMS_FIELDNAME, value, true);

    return data;
  };

  addToHotelPayload = (name, value) => {
    if (name === ROOMS_FIELDNAME) {
      /* istanbul ignore else */
      if (get(value, 'adult.value') && get(value, 'room.value')) {
        this.HotelsPayload[name] = value.room.value;
        this.HotelsPayload[ADULTS_TEXT] = value.adult.value;
      }
    } else {
      this.HotelsPayload[name] = value;
    }
  };

  setWidgetDataValue = val => {
    this.shouldUseWidgetData = val;
  };

  addToWidgetPayload = (name, value, isFirstLoad) => {
    if (name === ROOMS_FIELDNAME && !isFirstLoad) {
      this.widgetPayload[name] = this.widgetPayload[name] + 1;
    } else {
      this.widgetPayload[name] = value;
    }
  };

  reomveFromWidgetPayload = index => {
    let payload = {};
    payload = { ...payload, ...this.widgetPayload };
    const adultIndex = `adult_${index}`;
    const childIndex = `child_${index}`;
    delete payload[adultIndex];
    delete payload[childIndex];
    this.widgetPayload = payload;
  };

  // #TODO : Follow camel case
  getRoomsObject = (listItems, value) => {
    let roomsObject = '';
    for (let item of listItems) {
      if (get(item, 'fields.displayText.value') === value) {
        roomsObject = item.fields;
        break;
      }
    }

    return roomsObject;
  };

  onFieldChange = event => {
    const { name, value } = event.target;
    let { formData } = this.state;

    formData.map(data => {
      const { fieldName, listItems, endDateName, startDateName } = data.fields;
      if (fieldName.value === name) {
        data.fields.selectedValue.value = value;
        if (fieldName.value === ROOMS_FIELDNAME) {
          const RoomsObject = this.getRoomsObject(listItems, value);
          this.addToHotelPayload(fieldName.value, RoomsObject);
        } else {
          data.fields.showError = !value;
          this.addToHotelPayload(fieldName.value, value);
        }
      } else if (
        (endDateName && endDateName.value === name) ||
        (startDateName && startDateName.value === name)
      ) {
        if (name === CHECKIN_DATE) {
          data.fields.startDate.value = value;
          data.fields.endDate.value = '';
          this.addToHotelPayload(name, value);
        } else {
          data.fields.endDate.value = value;
          this.addToHotelPayload(name, value);
        }
      }
      return data;
    });
    this.setState({ formData });
  };

  onWidgetDataChange = event => {
    const { name, value } = event.target;
    let { widgetData } = this.state;

    widgetData.map(data => {
      data.fields.map(field => {
        if (get(field, 'fields.fieldName.value') === name) {
          field.fields.selectedValue.value = value;
          this.addToWidgetPayload(name, value, true);
        }
        return field;
      });
      return data;
    });

    this.setState({ widgetData });
  };

  onAddRoomClick = () => {
    let widgetData = cloneDeep(this.state.widgetData);
    let indexToUse = widgetData.length + 1;
    widgetData = [...widgetData, this.addWidgetData(indexToUse, indexToUse)];

    this.setState({ widgetData });
  };

  onRemoveClick = () => {
    let widgetData = cloneDeep(this.state.widgetData);
    let indexToUse = widgetData.length - 1;
    widgetData.splice(indexToUse, 1);
    this.reomveFromWidgetPayload(indexToUse + 1);
    this.setState({ widgetData });
  };

  HotelTabForm = classes => {
    const fields = this.state.formData.map((data, index) => {
      const fieldTypeValue = get(data, 'fields.fieldType.value');
      const Field = this.mapper[fieldTypeValue];
      if (fieldTypeValue === SUBMIT_TEXT) {
        this.redirectSitecoreURL = get(data, 'fields.submitActions[0].fields.redirectLink.value.href');
        return (
          <div className={clsx(classes.fullWidth, classes.button)}>
            <Field
              buttonType={'form'} //#TODO: This line is having warning on browser..need to look into it
              type={'submit'}
              size={'small'}
              hasBorder={false}
              key={index}
            >
              <Text field={data.fields.fieldLabel} />
            </Field>
          </div>
        );
      } else {
        if (fieldTypeValue === DATE_TEXT) {
          let monthsShown = 2;
          return (
            <Field
              data={data.fields}
              onChange={this.onFieldChange}
              monthsShown={monthsShown}
              key={index}
              shouldSetMinDate={true}
              componentName={"TabsWithForm"}
            />
          );
        } else if (get(data, 'fields.fieldName.value') === ROOMS_FIELDNAME) {
          return (
            <HotelGuestWidget
              data={data.fields}
              onChange={this.onFieldChange}
              widgetData={this.state.widgetForm}
              widget={this.state.widgetData}
              onWidgetDataChange={this.onWidgetDataChange}
              onRemoveClick={this.onRemoveClick}
              setWidgetDataValue={this.setWidgetDataValue}
              onAddRoomClick={this.onAddRoomClick}
              key={index}
            />
          );
        } else {
          //#TODO : check if this is needed here
          this.addToHotelPayload(
            get(data, 'fields.fieldName.value'),
            get(data, 'fields.selectedValue.value')
          );
          return (
            <Field
              data={data.fields}
              onChange={this.onFieldChange}
              key={index}
              componentName={"TabsWithForm"}
            />
          );
        }
      }
    });
    return <div className={classes.formWrapper}>{fields}</div>;
  };

  addAnalyticsData = (location, checkInDate, checkOutDate) => {
    const obj = {
      ...get(analyticsData, 'pageBodyInteraction.findDealClicks'),
      ...{
        action: `${get(analyticsData, 'dataLinksText.findDeals')}-${get(
          analyticsData,
          'dataLinksText.hotelFormText'
        )}`,
        label: createDynamicLabels([
          this.props.pageName,
          this.props.componentName,
          `${location}_${checkInDate}_${checkOutDate}`,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };

  redirectToTravelPayout = () => {
    let {
      destination,
      CheckIn_date,
      CheckOut_date,
      num_adults,
      num_children,
    } = this.HotelsPayload;
    CheckIn_date = moment(CheckIn_date).format('YYYY-MM-DD');
    CheckOut_date = moment(CheckOut_date).format('YYYY-MM-DD');
    this.addAnalyticsData(destination, CheckIn_date, CheckOut_date);
    const currency = getDictionaryText('currency');
    let searchURL = this.redirectSitecoreURL;
    let url = `${searchURL}?destination=${destination}&checkIn=${CheckIn_date
      }&checkOut=${CheckOut_date}&language=${this.language}${currency ? `&currency=${currency}` : ''}&children=${num_children}&adults=${num_adults}&with_request=true`;
    window.open(url);
  }

  redirectToWego = () => {
    let {
      destination,
      CheckIn_date,
      CheckOut_date,
      Adults,
      Rooms,
    } = this.HotelsPayload;

    CheckIn_date = moment(CheckIn_date).format('YYYY-MM-DD');
    CheckOut_date = moment(CheckOut_date).format('YYYY-MM-DD');
    this.addAnalyticsData(destination, CheckIn_date, CheckOut_date);
    let roomsURL = '';
    if (this.shouldUseWidgetData) {
      for (const key in this.widgetPayload) {
        var num = key.match(/-?\d+\.?\d*/);
        if (key.includes('adult')) {
          roomsURL += `&adults_${num[0]}=${this.widgetPayload[key]}`;
        } else if (key.includes('Room')) {
          roomsURL += `&${key}=${this.widgetPayload[key]}`;
        } else {
          let value = parseInt(this.widgetPayload[key]);
          let ages = '';
          if (value > 0) {
            while (value > 0) {
              ages += `8${value === 1 ? '' : ','}`;
              value--;
            }
            roomsURL += `&childAges_${num[0]}=${ages}`;
          }
        }
      }
    } else {
      roomsURL = `Adults=${Adults}&Rooms=${Rooms}`;
    }
    let searchURL = this.redirectSitecoreURL;
    let language;
    if (
      this.language.includes('-') &&
      this.language.split('-').length > 0 &&
      (this.language.split('-')[0] === 'ar' ||
        this.language.split('-')[0] === 'en')
    ) {
      language = this.language.split('-')[0].toUpperCase();
    } else if (
      this.language.includes('-') &&
      this.language.split('-').length > 0 &&
      this.language.split('-')[0] === 'zh'
    ) {
      language = this.language.split('-')[1].toUpperCase();
    } else {
      language = this.language.toUpperCase();
    }
    let url = `${searchURL}&destination=${destination}&checkin=${CheckIn_date}&checkout=${CheckOut_date}&${roomsURL}&languageCode=${language}&currencyCode=AED&sort=Rating-desc&star5=true&star4=true&star3=true&star2=true&star1=true`;
    window.open(url);
  }

  onFormSubmit = e => {
    e.preventDefault();
    const error = this.props.validateForm(this.rules, this.HotelsPayload);
    if (!isEmpty(error)) {
      let formData = this.state.formData;
      formData.map(data => {
        if (error[get(data, 'fields.fieldName.value')]) {
          data.fields.showError = error[get(data, 'fields.fieldName.value')];
        }
        return data;
      });

      this.setState({ formData });
    } else {
      if (this.props.formType && this.props.formType.value === FORM_TYPE_TO_CHECK_HOTEL) {
        this.redirectToTravelPayout();
      } else {
        this.redirectToWego();
      }
    }
  };

  render() {
    if (this.state.formData.length === 0) {
      return '';
    }
    const { classes } = this.props;

    return (
      <Form onSubmit={this.onFormSubmit}>{this.HotelTabForm(classes)}</Form>
    );
  }
}

export default withSitecoreContext()(HotelForm);
